module.exports = __webpack_public_path__ + "static/media/download.fff15ce2.svg";